'use strict';

/**
 * Shared change-order gating — mirrors contract_admin's ProjectChangeOrderGating service.
 *
 * A project requires a Change Order for line-item / bid-item MODIFICATIONS when its current Status is in the
 * ProjectType's `RequiresChangeOrder` status list (`GET ProjectType/{id}/Statuses` → `.RequiresChangeOrder`).
 * This is a UX rule only (the API still writes regardless); the config app disables the direct line-item edit
 * affordances (Funding line-item category assignment, line/bid-item bulk delete) and points the user at the
 * Change Orders tab instead.
 *
 * @param {Function} pGetJSON - a promise-returning GET, `(url) => Promise<any>`.
 * @param {number} pIDProject
 * @param {object} [pProject] - an already-loaded Project record (with Status + IDProjectType) to skip the extra fetch.
 * @returns {Promise<{ requires: boolean, status: string, idProjectType: number }>}
 */
async function fetchProjectChangeOrderGating(pGetJSON, pIDProject, pProject)
{
	let tmpStatus = '';
	let tmpIDProjectType = 0;
	try
	{
		const tmpProject = (pProject && typeof pProject === 'object') ? pProject : await pGetJSON(`Project/${pIDProject}`);
		tmpStatus = (tmpProject && tmpProject.Status) ? String(tmpProject.Status) : '';
		tmpIDProjectType = (tmpProject && tmpProject.IDProjectType) ? Number(tmpProject.IDProjectType) : 0;
		if (tmpIDProjectType)
		{
			const tmpStatuses = await pGetJSON(`ProjectType/${tmpIDProjectType}/Statuses`).catch(() => null);
			const tmpList = (tmpStatuses && Array.isArray(tmpStatuses.RequiresChangeOrder)) ? tmpStatuses.RequiresChangeOrder : [];
			return { requires: tmpStatus ? (tmpList.indexOf(tmpStatus) > -1) : false, status: tmpStatus, idProjectType: tmpIDProjectType };
		}
	}
	catch (pError) { /* best-effort — default to direct (not required) */ }
	return { requires: false, status: tmpStatus, idProjectType: tmpIDProjectType };
}

module.exports = { fetchProjectChangeOrderGating };
